import Request from '../Request.utils'
export interface ICreatePendingOrderRequestBody {
  customerNumber: string;
  externalDocumentNumber: string;
  lines: ({
    budgetCategory?: string | '' | null;
    itemNo: string;
    quantity: number;
  })[];
  locationExternalId: string;
  note?: string | '' | null;
  variantId?: undefined;
}
export interface IListOrdersRequestQuery {
  status?: 'pending' | 'approved' | 'rejected';
}
export interface IGetOrderRequestQuery {
  orderId: string;
}
export interface IApproveOrderRequestBody {
  orderId: string;
}
export interface IReleaseOrderRequestBody {
  holdException?: {
    reason: string;
  };
  orderId: string;
}
export interface IBulkOrderActionRequestBody {
  action: 'approve' | 'release' | 'retry';
  orderIds: string[];
}
export interface IAmendOrderRequestBody {
  amendReason?: string | '' | null;
  lines: ({
    budgetCategory?: string | '' | null;
    itemNo: string;
    quantity: number;
  })[];
  note?: string | '' | null;
  orderId: string;
}
export interface IRejectOrderRequestBody {
  orderId: string;
  reason: string;
}
export interface ISetAccountHoldRequestBody {
  active: boolean;
  companyId: string;
  reason: string;
}
export interface IListCreditAccountsRequestQuery {
  companyId?: string;
}


class McentralAPI {
  createPendingOrder = async (body: ICreatePendingOrderRequestBody) => {
    const res = await Request.call('/api/mcentral/create-pending-order', 'POST', undefined, undefined, body, );
    return res;
  }
  listOrders = async (query: IListOrdersRequestQuery) => {
    const res = await Request.call('/api/mcentral/list-orders', 'GET', undefined, query, undefined, );
    return res;
  }
  getOrder = async (query: IGetOrderRequestQuery) => {
    const res = await Request.call('/api/mcentral/get-order', 'GET', undefined, query, undefined, );
    return res;
  }
  approveOrder = async (body: IApproveOrderRequestBody) => {
    const res = await Request.call('/api/mcentral/approve-order', 'POST', undefined, undefined, body, );
    return res;
  }
  releaseOrder = async (body: IReleaseOrderRequestBody) => {
    const res = await Request.call('/api/mcentral/release-order', 'POST', undefined, undefined, body, );
    return res;
  }
  bulkOrderAction = async (body: IBulkOrderActionRequestBody) => {
    const res = await Request.call('/api/mcentral/bulk-order-action', 'POST', undefined, undefined, body, );
    return res;
  }
  amendOrder = async (body: IAmendOrderRequestBody) => {
    const res = await Request.call('/api/mcentral/amend-order', 'POST', undefined, undefined, body, );
    return res;
  }
  rejectOrder = async (body: IRejectOrderRequestBody) => {
    const res = await Request.call('/api/mcentral/reject-order', 'POST', undefined, undefined, body, );
    return res;
  }
  setAccountHold = async (body: ISetAccountHoldRequestBody) => {
    const res = await Request.call('/api/mcentral/set-account-hold', 'POST', undefined, undefined, body, );
    return res;
  }
  listCreditAccounts = async (query: IListCreditAccountsRequestQuery) => {
    const res = await Request.call('/api/mcentral/list-credit-accounts', 'GET', undefined, query, undefined, );
    return res;
  }
}
export default new McentralAPI()